<template>
  <div
    class="grid-container"
    :class="className"
    :style="{gridTemplateColumns: `repeat(${cols}, 1fr)`}"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ['cols', 'className'],
}
</script>
<style lang="scss">
@import "@/create/assets/scss/style.scss";

.grid-container {
  display: grid;
}
</style>
